// import * as WaveSurfer from 'wavesurfer.js';
import { APP_BASE_HREF } from '@angular/common';
import { AfterViewInit, Component, ElementRef, ViewEncapsulation, ViewChild, Inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { saveAs as fileSaverSave } from 'file-saver';
import videojs from 'video.js';

/*
// Required imports when using videojs-wavesurfer 'live' mode with the microphone plugin
import * as adapter from 'webrtc-adapter/out/adapter_no_global.js';
import * as MicrophonePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.microphone.js';
WaveSurfer.microphone = MicrophonePlugin;
*/
// Register videojs-wavesurfer plugin
import * as Wavesurfer from 'videojs-wavesurfer/dist/videojs.wavesurfer.js';
import { WindowsWrapper } from '@app/app.config'
import { textContent } from 'video.js/dist/types/utils/dom';
const Button = videojs.getComponent('Button');

@Component({
  selector: 'app-videojs-wavesurfer',
  templateUrl: './videojs-wavesurfer.component.html',
  styleUrls: ['./videojs-wavesurfer.component.scss'],

})
export class VideojsWavesurferComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  // reference to the element itself: used to access events and methods
  private config: any;
  private player: any;
  private plugin: any;
  audioSource = '';
  @Input() filename: string;
  @Input() recordingDetails: string;
  @Input() index: string;
  @Input() IsAudio: boolean = true
  isUsingWrapper: boolean = false;
  // index to create unique ID for component
  idx = 'clip1';
  videoConfig: {};
  audioConfig: {
    controls: boolean; bigPlayButton: boolean; autoplay: boolean; fluid: boolean; loop: boolean; width: number; height: number; plugins: {
      // configure videojs-wavesurfer plugin
      wavesurfer: { backend: string; displayMilliseconds: boolean; debug: boolean; waveColor: string; progressColor: string; cursorColor: string; hideScrollbar: boolean; };
    };
  };

  // constructor initializes our declared vars
  constructor(
    @Inject(APP_BASE_HREF) public baseHref: string,
    @Inject(WindowsWrapper) private OnvidaWrapper: any,
  ) {

    this.player = false;

    // save reference to plugin (so it initializes)
    this.plugin = Wavesurfer;

    // video.js configuration
    this.audioConfig = {
      controls: true,
      bigPlayButton: false,
      autoplay: false,
      fluid: false,
      loop: false,
      width: 250,
      height: 200,
      plugins: {
        // configure videojs-wavesurfer plugin
        wavesurfer: {
          backend: 'MediaElement',
          displayMilliseconds: false,
          debug: true,
          waveColor: '#0a0a57',
          progressColor: '#000048',
          cursorColor: '#5d5d5f',
          hideScrollbar: true,
        },
      },
    };
    {
      // hide fullscreen control
      false;
    }

    this.videoConfig = {
      controls: true,
      bigPlayButton: false,
      autoplay: false,
      fluid: false,
      loop: false,
      width: 250,
      height: 200,
      preload: 'auto'
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("Changes", changes);
    this.recordingDetails = changes['recordingDetails'].currentValue;
    this.audioSource = this.recordingDetails;
    if (this.player) {
      if (this.IsAudio) {
        this.player.src({ src: this.recordingDetails, type: 'audio/wav' });
      }
      else {
        this.player.src({ src: this.recordingDetails, type: 'video/mp4' });
      }
    }
  }

  ngOnInit() {
    this.isUsingWrapper = this.OnvidaWrapper.IsWrapper;
    console.log('Wrapper', this.OnvidaWrapper);
    this.idx = this.index ? this.index : this.idx
    this.config = this.IsAudio ? this.audioConfig : this.videoConfig;
    console.log(this.recordingDetails);
    this.audioSource = this.recordingDetails;
  }
  // use ngOnDestroy to detach event handlers and remove the player
  ngOnDestroy() {
    if (this.player) {
      this.player.dispose();
      this.player = false;
    }
    console.log('Player destroy');
  }
  InitializePlayer() {
    console.log(this.player.src, this.audioSource);
    let el = (this.IsAudio ? 'audio_' : 'video_') + this.idx;

    // setup the player via the unique element ID
    if (document.getElementById(el)) {
      this.player = videojs(document.getElementById(el), this.config, () => {
        console.log('player ready! id:', el);
        console.log('player ready! this.config:', this.config);

        // Add custom button
      
        const customButton = new Button(this.player, {
          
        }); 
      //customButton.addClass('vjs-icon-file-download'); 
      customButton.addClass('vjs-icon-downloading');
      customButton.el().setAttribute('title','Download');
      customButton.removeClass('vjs-control');
      customButton.removeClass('vjs-button');
     console.log();
        customButton.on('click', () => {
          console.log('Custom button clicked!');
          this.player.trigger('customEvent');
        });

        this.player.getChild('controlBar')?.addChild(customButton, {}, this.player.getChild('controlBar')?.children().length - 1);

        // Listen to custom event
        this.player.on('customEvent', () => {
          console.log(this.recordingDetails, this.audioSource);
          //alert('Custom event triggered!');
          //this.VideoFileDownload();
          //this.downloadFile(this.recordingDetails);
          this.download();
        });

        /* const myButton = this.player.controlBar.addChild('button', {}, 19);
         const myButtonDom = myButton.el();
         myButtonDom.innerHTML = '<span class="vjs-icon-file-download"></span>';
          myButtonDom.onclick = function () {
           
           const fileName = 'Recording';
           let BLOB:any;
           if(this.IsAudio){ 
             BLOB = new Blob([this.recordingDetails], { type: 'audio/mp3' });
           }
           else{
             BLOB = new Blob([this.recordingDetails], { type: 'video/mp4' });
           }
           console.log(this.recordingDetails,this.audioSource); 
           
           fileSaverSave(BLOB, fileName);
         }; 
         */
        if (this.recordingDetails) {
          if (this.IsAudio) {
            this.player.src({ src: this.recordingDetails, type: 'audio/wav' });
          }
          else {
            this.player.src({ src: this.recordingDetails, type: 'video/mp4' });
          }
        }

      });

      this.player.on('waveReady', event => {
        console.log('waveform is ready!');
      });

      this.player.on('playbackFinish', event => {
        console.log('playback finished.');
      });

      // error handling
      this.player.on('error', (element, error) => {
        console.warn(error);
      });

      this.player.on('deviceError', () => {
        console.error('device error:', this.player.deviceErrorCode);
      });
    }
  }
  ngAfterViewInit() {
    this.InitializePlayer();
  }
  download() {
    fileSaverSave(this.recordingDetails, this.filename);
  }
} 